import script from "./tab-pane-simple.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-pane-simple.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__